/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type MeasurementSystem = typeof MeasurementSystem[keyof typeof MeasurementSystem];


export const MeasurementSystem = {
  metric: 'metric',
  imperial: 'imperial',
} as const;
